var e = require("object-assign"),
    t = require("compass-vertical-rhythm"),
    i = require("modularscale"),
    o = require("gray-percentage"),
    r = require("lodash/set"),
    n = require("lodash/forEach"),
    a = require("lodash/isNumber"),
    l = require("lodash/isString"),
    d = require("lodash/isFunction"),
    u = require("lodash/isArray"),
    s = require("lodash/merge"),
    h = require("lodash/reduce"),
    g = require("typography-normalize"),
    c = require("decamelize"),
    f = require("lodash/isObject");

function m(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

var p = m(e),
    y = m(t),
    b = m(i),
    S = m(o),
    F = m(r),
    v = m(n),
    B = m(a),
    k = m(l),
    x = m(d),
    z = m(u),
    q = m(s),
    j = m(h),
    L = m(g),
    W = m(c),
    T = m(f);

function M() {
  return (M = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];

      for (var o in i) {
        Object.prototype.hasOwnProperty.call(i, o) && (e[o] = i[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var C = function C(e, t, i) {
  var o;
  return void 0 === e && (e = {}), o = z.default(t) ? t : [t], v.default(o, function (t) {
    v.default(i, function (i, o) {
      F.default(e, t + "." + o, i);
    });
  }), e;
},
    O = ["inherit", "default", "serif", "sans-serif", "monospace", "fantasy", "cursive", "-apple-system"],
    R = function R(e) {
  return -1 !== O.indexOf(e) ? e : "'" + e + "'";
},
    H = function e(t) {
  return j.default(t, function (t, i, o) {
    return t += o + "{", v.default(i, function (i, o) {
      if (T.default(i)) {
        var r = {};
        r[o] = i, t += e(r);
      } else {
        var n = W.default(o, "-") + ":" + i + ";";
        ["Webkit", "ms", "Moz", "O"].forEach(function (e) {
          o.slice(0, e.length) === e && (n = "-" + n);
        }), t += n;
      }
    }), t += "}";
  }, "");
},
    N = function N(e, t, i) {
  var o = H(i);
  return t.includeNormalize && (o = "" + L.default + o), o;
};

module.exports = function (e) {
  var t = p.default({}, {
    baseFontSize: "16px",
    baseLineHeight: 1.45,
    headerLineHeight: 1.1,
    scaleRatio: 2,
    googleFonts: [],
    headerFontFamily: ["-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "sans-serif"],
    bodyFontFamily: ["georgia", "serif"],
    headerColor: "inherit",
    bodyColor: "hsla(0,0%,0%,0.8)",
    headerWeight: "bold",
    bodyWeight: "normal",
    boldWeight: "bold",
    includeNormalize: !0,
    blockMarginBottom: 1
  }, e),
      i = y.default(t);
  return i.scale = function (e) {
    var o = parseInt(t.baseFontSize, 10),
        r = b.default(e, t.scaleRatio) * o + "px";
    return i.adjustFontSizeTo(r);
  }, M({
    options: t
  }, i, {
    createStyles: function createStyles() {
      return this.toString();
    },
    toJSON: function toJSON() {
      return function (e, t) {
        var i,
            o = {},
            r = e.establishBaseline();
        o = C(o, "html", {
          font: r.fontSize + "/" + r.lineHeight + " " + t.bodyFontFamily.map(R).join(","),
          boxSizing: "border-box",
          overflowY: "scroll"
        }), o = C(o, ["*", "*:before", "*:after"], {
          boxSizing: "inherit"
        }), o = C(o, "body", {
          color: t.bodyColor,
          fontFamily: t.bodyFontFamily.map(R).join(","),
          fontWeight: t.bodyWeight,
          wordWrap: "break-word",
          fontKerning: "normal",
          MozFontFeatureSettings: '"kern", "liga", "clig", "calt"',
          msFontFeatureSettings: '"kern", "liga", "clig", "calt"',
          WebkitFontFeatureSettings: '"kern", "liga", "clig", "calt"',
          fontFeatureSettings: '"kern", "liga", "clig", "calt"'
        }), o = C(o, "img", {
          maxWidth: "100%"
        }), i = B.default(t.blockMarginBottom) ? e.rhythm(t.blockMarginBottom) : k.default(t.blockMarginBottom) ? t.blockMarginBottom : e.rhythm(1), o = C(o, ["h1", "h2", "h3", "h4", "h5", "h6", "hgroup", "ul", "ol", "dl", "dd", "p", "figure", "pre", "table", "fieldset", "blockquote", "form", "noscript", "iframe", "img", "hr", "address"], {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
          marginBottom: i
        }), o = C(o, "blockquote", {
          marginRight: e.rhythm(1),
          marginBottom: i,
          marginLeft: e.rhythm(1)
        }), o = C(o, ["b", "strong", "dt", "th"], {
          fontWeight: t.boldWeight
        }), o = C(o, "hr", {
          background: S.default(80),
          border: "none",
          height: "1px",
          marginBottom: "calc(" + i + " - 1px)"
        }), o = C(o, ["ol", "ul"], {
          listStylePosition: "outside",
          listStyleImage: "none",
          marginLeft: e.rhythm(1)
        }), o = C(o, "li", {
          marginBottom: "calc(" + i + " / 2)"
        }), o = C(o, ["ol li", "ul li"], {
          paddingLeft: 0
        }), o = C(o, ["li > ol", "li > ul"], {
          marginLeft: e.rhythm(1),
          marginBottom: "calc(" + i + " / 2)",
          marginTop: "calc(" + i + " / 2)"
        }), o = C(o, ["blockquote *:last-child", "li *:last-child", "p *:last-child"], {
          marginBottom: 0
        }), o = C(o, ["li > p"], {
          marginBottom: "calc(" + i + " / 2)"
        }), o = C(o, ["code", "kbd", "pre", "samp"], M({}, e.adjustFontSizeTo("85%"))), (o = C(o, ["abbr", "acronym"], {
          borderBottom: "1px dotted " + S.default(50),
          cursor: "help"
        }))["abbr[title]"] = {
          borderBottom: "1px dotted " + S.default(50),
          cursor: "help",
          textDecoration: "none"
        }, o = C(o, ["table"], M({}, e.adjustFontSizeTo(t.baseFontSize), {
          borderCollapse: "collapse",
          width: "100%"
        })), o = C(o, ["thead"], {
          textAlign: "left"
        }), o = C(o, ["td,th"], {
          textAlign: "left",
          borderBottom: "1px solid " + S.default(88),
          fontFeatureSettings: '"tnum"',
          MozFontFeatureSettings: '"tnum"',
          msFontFeatureSettings: '"tnum"',
          WebkitFontFeatureSettings: '"tnum"',
          paddingLeft: e.rhythm(2 / 3),
          paddingRight: e.rhythm(2 / 3),
          paddingTop: e.rhythm(.5),
          paddingBottom: "calc(" + e.rhythm(.5) + " - 1px)"
        }), o = C(o, "th:first-child,td:first-child", {
          paddingLeft: 0
        }), o = C(o, "th:last-child,td:last-child", {
          paddingRight: 0
        }), o = C(o, ["h1", "h2", "h3", "h4", "h5", "h6"], {
          color: t.headerColor,
          fontFamily: t.headerFontFamily.map(R).join(","),
          fontWeight: t.headerWeight,
          textRendering: "optimizeLegibility"
        });
        var n = e.scale(1),
            a = e.scale(.6),
            l = e.scale(.4),
            d = e.scale(0),
            u = e.scale(-.2),
            s = e.scale(-.3);
        return v.default([n, a, l, d, u, s], function (e, i) {
          o = F.default(o, "h" + (i + 1) + ".fontSize", e.fontSize), o = F.default(o, "h" + (i + 1) + ".lineHeight", t.headerLineHeight);
        }), z.default(t.plugins) && (o = j.default(t.plugins, function (i, o) {
          return q.default(i, o(e, t, i));
        }, o)), t.overrideStyles && x.default(t.overrideStyles) && (o = q.default(o, t.overrideStyles(e, t, o))), t.overrideThemeStyles && x.default(t.overrideThemeStyles) && (o = q.default(o, t.overrideThemeStyles(e, t, o))), o;
      }(i, t);
    },
    toString: function toString() {
      return N(0, t, this.toJSON());
    },
    injectStyles: function injectStyles() {
      if ("undefined" != typeof document) if (document.getElementById("typography.js")) document.getElementById("typography.js").innerHTML = this.toString();else {
        var e = document.createElement("style");
        e.id = "typography.js", e.innerHTML = this.toString();
        var t = document.head;
        t.firstChild ? t.insertBefore(e, t.firstChild) : t.appendChild(e);
      }
    }
  });
};